import { render, staticRenderFns } from "./WasteCollectList.vue?vue&type=template&id=27071e7c&scoped=true&"
import script from "./WasteCollectList.vue?vue&type=script&lang=js&"
export * from "./WasteCollectList.vue?vue&type=script&lang=js&"
import style0 from "./WasteCollectList.vue?vue&type=style&index=0&id=27071e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27071e7c",
  null
  
)

export default component.exports